<!--  -->
<template>
  <div>
    <div>
      <el-form ref="ruleForm" :model="parameter" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="parameter.title" v-model.trim="parameter.title" style="width:300px" @input="parameter.title = parameter.title.replace(reg, '')" />
        </el-form-item>
        <el-form-item label="赠送数量" prop="amount">
          <el-input v-model="parameter.amount" style="width:300px" type="number" @blur="rednum" />
        </el-form-item>
        <el-form-item label="赠送名额" prop="giftNum">
          <el-input v-model="parameter.giftNum" style="width:300px" type="number" @blur="giftnum" />
        </el-form-item>
        <el-form-item label="期限选择">
          <el-select v-model="time_type" placeholder="请选择">
            <el-option
              v-for="item in timeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
          <el-input v-model="parameter.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="parameter.appoint_day = parameter.appoint_day.replace(/[^A-z0-9]/, '')" />
        </el-form-item>
        <el-form-item v-if="time_type === 1" label="活动时间" prop="date">
          <el-date-picker
            v-model="parameter.date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:410px"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="datavalue"
          />

        </el-form-item>
        <el-form-item label="活动展示">
          <div>
            <el-checkbox v-model="checked" :true-label="1" :false-label="0">阅读页banner</el-checkbox>
            <el-checkbox v-model="checkedindex" :true-label="1" :false-label="0">首页banner</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: { },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.date[0] == this.parameter.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        title: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入赠送数量', trigger: 'blur' }
        ],
        giftNum: [
          { required: true, message: '请输入赠送名额', trigger: 'blur' }
        ],
        date: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      },

      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      checked: 0,
      checkedindex: 0,
      parameter: {
        stime: null, // 开始时间
        etime: null, // 结束时间
        title: null, // 标题
        date: [],
        amount: '', // 赠送数量
        giftNum: '', // 赠送名额
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {
  },
  mounted() {

  },

  methods: {
    datavalue(val) {
      this.parameter.stime = val[0]
      this.parameter.etime = val[1]
    },
    rednum() {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.amount <= 0 && this.parameter.amount != '') {
        this.parameter.amount = 1
      }
      // 判断不能输入小数点
      const str = '' + this.parameter.amount
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.parameter.amount = 1
      }
    },
    giftnum() {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.giftNum <= 0 && this.parameter.giftNum != '') {
        this.parameter.giftNum = 1
      }
      // 判断不能输入小数点
      const str = '' + this.parameter.giftNum
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.parameter.giftNum = 1
      }
    },
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.parameter.stime
            par.end_time = this.parameter.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.parameter.appoint_day)
          }
          try {
            await readingservice({
              platform_id: this.platformid,
              activity_type: 4,
              ...par,
              activity_info: {
                readSwitch: this.checked,
                homeSwitch: this.checkedindex,
                amount: this.parameter.amount,
                giftNum: this.parameter.giftNum,
                name: this.parameter.title
                // startTime: this.parameter.stime,
                // endTime: this.parameter.etime
              }
            })
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          } catch (err) {
            this.$message({
              message: err,
              type: 'warning'
            })
          }
        } else {
          false
        }
      })
    }

  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }

</style>

